<template>
  <section :data-theme="theme" v-intersection-observer="onIntersectionObserver">
    <div class="hero min-h-screen bg-base-100 p-4">
      <div class="hero-content flex-col lg:flex-row">
        <!-- mt-12 sm:mt-0 -->
        <img :src="imageAboutMe()" class="max-w-sm hidden md:block" />
        <div>
          <h1 class="text-5xl font-bold">Sobre mí</h1>
          <p class="py-6 text-xl sm:text-2xl">
            Hola, soy Rodrigo. Un placer conocerte. Desde que comencé mi viaje
            como programador en el 2020, he trabajado a distancia, colaborando
            con personas talentosas para crear productos digitales para uso
            comercial y de consumo. Abriendo oportunidades al trabajar con tipos
            de tecnologías. Estoy tranquilamente confiado, naturalmente curioso
            y trabajando constantemente para mejorar mis habilidades, un
            problema de desarrollo a la vez.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useStore } from "vuex";
import { ref } from "vue";

import { vIntersectionObserver } from "@vueuse/components";

const isVisible = ref(false);

function onIntersectionObserver([{ isIntersecting }]) {
  if (isIntersecting) {
    store.dispatch("setTheme", theme.value);
  }
  isVisible.value = isIntersecting;
}

const theme = ref("business");
const store = useStore();

const imageAboutMe = () => {
  return require(`@/assets/images/programming_activity.svg`);
};
</script>

<style>
</style>
